import React, { useEffect, useState, useRef } from 'react';
import { Plus, Calendar, ChevronDown, X } from 'lucide-react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import api from '../../../api/axios'; // <-- use your configured api

const KPITilesSection = () => {
  const [dateFilter, setDateFilter] = useState('Last 7 Days');
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [showCustomRange, setShowCustomRange] = useState(false);
  const [showMetricSelector, setShowMetricSelector] = useState(false);

  const [allKPIData, setAllKPIData] = useState([]);
  const [visibleTiles, setVisibleTiles] = useState([]);
  const [loading, setLoading] = useState(true);

  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');

  // Preference persistence
  const savedTileIdsRef = useRef(null);
  const saveTimerRef = useRef(null);

  // Agent filter - independent for this widget
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState('');

  useEffect(() => {
    api.get('/api/v1/dashboard/get-agents')
      .then((res) => {
        const list = res.data?.data?.agents || [];
        setAgents(list);
      })
      .catch((err) => console.error('Failed to fetch agents:', err));

    // Fetch saved preferences on mount
    api.get('/api/v1/dashboard/preferences')
      .then((res) => {
        const prefs = res.data?.data;
        if (prefs?.kpiTileIds?.length > 0) {
          savedTileIdsRef.current = prefs.kpiTileIds;
        }
      })
      .catch(() => {});
  }, []);

  const dateFilterOptions = [
    'Today',
    'Yesterday',
    'Last 7 Days',
    'Last 14 Days',
    'Last Month',
    'Custom Range'
  ];

  // ---------------- API ----------------
  // const fetchKpis = async (days) => {
  //   try {
  //     setLoading(true);

  //     const res = await fetch(
  //       `http://localhost:8080/api/v1/dashboard/kpi-metrics?durationInDays=${days}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwiaWF0IjoxNzY4Mzk3NjEwLCJleHAiOjE3OTk5MzM2MTB9.gvjuyisvIcI2K4zrtt-UbsDhGDkZhGRmLM-zf3qyovw`,
  //         },
  //       }
  //     );

  //     if (!res.ok) throw new Error('Failed to fetch KPIs');

  //    const json = await res.json();
  //    const data = json.data;
  //     setAllKPIData(data);
  //     setVisibleTiles(data.slice(0, 6)); // default tiles
  //   } catch (err) {
  //     console.error('KPI fetch error:', err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


   // ---------------- API (LATEST ARCH) ----------------
  const fetchKpis = async (from, to) => {
    try {
      setLoading(true);

      const params = { from, to };
      if (selectedAgent) params.agentId = selectedAgent;

      const response = await api.get(
        `/api/v1/dashboard/kpi-metrics`,
        { params }
      );

      if (!response.data?.success) {
        throw new Error(response.data?.message || 'Operation failed');
      }

      const data = response.data.data;
      setAllKPIData(data);

      // Apply saved preferences if available
      if (savedTileIdsRef.current) {
        const ordered = savedTileIdsRef.current
          .map(id => data.find(kpi => String(kpi.id) === String(id)))
          .filter(Boolean);
        setVisibleTiles(ordered.length > 0 ? ordered : data.slice(0, 6));
      } else {
        setVisibleTiles(data.slice(0, 6));
      }
    } catch (err) {
      console.error('KPI fetch error:', err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  const to = new Date();
  const from = new Date();
  from.setDate(to.getDate() - 7);

  fetchKpis(
    toLocalISOString(from),
    toLocalISOString(to)
  )
  }, [selectedAgent]);

  const toLocalISOString = (date) =>
  date.toISOString().slice(0, 19); // yyyy-MM-ddTHH:mm:ss

  // ---------------- Date Filter ----------------
  // const handleDateFilterChange = (option) => {
  //   let days = 7;

  //   switch (option) {
  //     case 'Today':
  //       days = 1;
  //       break;
  //     case 'Yesterday':
  //       days = 1;
  //       break;
  //     case 'Last 7 Days':
  //       days = 7;
  //       break;
  //     case 'Last 14 Days':
  //       days = 14;
  //       break;
  //     case 'Last Month':
  //       days = 30;
  //       break;
  //     case 'Custom Range':
  //       setDateFilter(option);
  //       setShowCustomRange(true);
  //       setShowDateDropdown(false);
  //       return;
  //     default:
  //       break;
  //   }

  //   setShowCustomRange(false);
  //   setDateFilter(option);
  //   setShowDateDropdown(false);
  //   fetchKpis(days);
  // };

  const handleDateFilterChange = (option) => {
  const now = new Date();
  let from = new Date();
  let to = new Date();

  switch (option) {
    case 'Today':
      from.setHours(0, 0, 0, 0);
      break;

    case 'Yesterday':
      from.setDate(from.getDate() - 1);
      to.setDate(to.getDate() - 1);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;

    case 'Last 7 Days':
      from.setDate(to.getDate() - 7);
      break;

    case 'Last 14 Days':
      from.setDate(to.getDate() - 14);
      break;

    case 'Last Month':
      from.setDate(to.getDate() - 30);
      break;

    case 'Custom Range':
      setDateFilter(option);
      setShowCustomRange(true);
      setShowDateDropdown(false);
      return;

    default:
      return;
  }

  setShowCustomRange(false);
  setDateFilter(option);
  setShowDateDropdown(false);

  fetchKpis(
    toLocalISOString(from),
    toLocalISOString(to)
  );
};


  // const applyCustomRange = () => {
  //   if (!customStartDate || !customEndDate) return;

  //   const start = new Date(customStartDate);
  //   const end = new Date(customEndDate);
  //   const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

  //   fetchKpis(days);
  //   setShowCustomRange(false);
  // };


  const applyCustomRange = () => {
  if (!customStartDate || !customEndDate) return;

  const from = new Date(customStartDate);
  const to = new Date(customEndDate);

  // normalize
  from.setHours(0, 0, 0, 0);
  to.setHours(23, 59, 59, 999);

  fetchKpis(
    toLocalISOString(from),
    toLocalISOString(to)
  );

  setShowCustomRange(false);
};


  

  // ---------------- Preference Save ----------------
  const saveKpiPreferences = (tiles) => {
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    saveTimerRef.current = setTimeout(() => {
      const kpiTileIds = tiles.map(t => String(t.id));
      api.put('/api/v1/dashboard/preferences', { kpiTileIds })
        .catch(err => console.error('Failed to save KPI preferences:', err));
    }, 500);
  };

  // ---------------- Tile Controls ----------------
  const handleAddTile = (metric) => {
    const updated = [...visibleTiles, metric];
    setVisibleTiles(updated);
    setShowMetricSelector(false);
    saveKpiPreferences(updated);
  };

  const handleRemoveTile = (id) => {
    const updated = visibleTiles.filter((tile) => tile.id !== id);
    setVisibleTiles(updated);
    saveKpiPreferences(updated);
  };

  const availableMetrics = allKPIData.filter(
    (metric) => !visibleTiles.some((tile) => tile.id === metric.id)
  );

  // ---------------- Sparkline ----------------

  const renderSparkline = (sparklineData) => {
  if (!sparklineData || sparklineData.length === 0) return null;

  const max = Math.max(...sparklineData);
  const min = Math.min(...sparklineData);
  const range = max - min || 1;

  // padding top/bottom (10% of height)
  const padding = 10;

  // convert data to points
  const points = sparklineData.map((value, index) => {
    const x = (index / (sparklineData.length - 1)) * 100;
    const y = padding + ((max - value) / range) * (100 - 2 * padding);
    return { x, y };
  });

  // generate path string
  const pathD = points
    .map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`)
    .join(' ');

  return (
    <svg
      className="w-full h-12 mt-3"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <path
        d={pathD}
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
        opacity="0.8"
      />
    </svg>
  );
};


  // const renderSparkline = (sparklineData) => {
  //   if (!sparklineData || sparklineData.length === 0) return null;

  //   const max = Math.max(...sparklineData);
  //   const min = Math.min(...sparklineData);
  //   const range = max - min || 1;

  //   const points = sparklineData
  //     .map((value, index) => {
  //       const x = (index / (sparklineData.length - 1)) * 100;
  //       const y = 100 - ((value - min) / range) * 100;
  //       return `${x},${y}`;
  //     })
  //     .join(' ');

  //   return (
  //     <svg className="w-full h-12 mt-3" viewBox="0 0 100 100" preserveAspectRatio="none">
  //       <polyline
  // points={points}
  // fill="none"
  // stroke="currentColor"
  // strokeWidth="2"       // thickness
  // strokeLinecap="round" // smooth edges
  // strokeLinejoin="round" // smooth joins
  // vectorEffect="non-scaling-stroke" // keeps thickness consistent when scaling
  // opacity="0.8"
  //       />
  //     </svg>
  //   );
  // };

  // ---------------- UI ----------------
  return (
    <div className="bg-white rounded-lg border border-border shadow-sm p-6 mb-6 md:mb-8">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-1">KPI Metrics</h2>
          <p className="text-sm text-muted-foreground">
            Track key performance indicators across all channels
          </p>
        </div>

        {/* Agent Filter + Date Filter */}
        <div className="flex items-center gap-3">
          <Select
            options={[
              { value: '', label: 'All Agents' },
              ...agents.map(a => ({ value: a.agentId, label: a.agentName }))
            ]}
            value={selectedAgent}
            onChange={setSelectedAgent}
            placeholder="Select agent"
          />

        {/* Date Filter */}
        <div className="relative">
          <button
            onClick={() => setShowDateDropdown(!showDateDropdown)}
            className="flex items-center gap-2 px-4 py-2 bg-white border border-border rounded-lg hover:bg-gray-50 text-sm font-medium"
          >
            <Calendar className="w-4 h-4 text-muted-foreground" />
            <span>{dateFilter}</span>
            <ChevronDown className="w-4 h-4 text-muted-foreground" />
          </button>

          {showDateDropdown && (
            <div className="absolute right-0 mt-2 w-48 bg-white border border-border rounded-lg shadow-lg z-10">
              {dateFilterOptions.map((option) => (
                <button
                  key={option}
                  onClick={() => handleDateFilterChange(option)}
                  className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 ${
                    dateFilter === option
                      ? 'bg-blue-50 text-blue-700 font-medium'
                      : ''
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          )}
        </div>
        </div>
      </div>

      {/* Custom Range */}
      {showCustomRange && (
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-border">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <label className="block text-sm font-medium mb-1">Start Date</label>
              <input
                type="date"
                value={customStartDate}
                onChange={(e) => setCustomStartDate(e.target.value)}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium mb-1">End Date</label>
              <input
                type="date"
                value={customEndDate}
                onChange={(e) => setCustomEndDate(e.target.value)}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>
            <div className="flex items-end">
              <Button className="px-6" onClick={applyCustomRange}>Apply</Button>
            </div>
          </div>
        </div>
      )}

      {/* Loading */}
      {loading ? (
        <div className="py-12 text-center text-muted-foreground">
          Loading KPI metrics...
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {visibleTiles.map((kpi) => (
            <div
              key={kpi.id}
              className="bg-card border border-border rounded-lg p-4 md:p-6 relative group hover:shadow-lg"
            >
              <button
                onClick={() => handleRemoveTile(kpi.id)}
                className="absolute top-3 right-3 w-6 h-6 rounded-full bg-gray-100 hover:bg-red-100 flex items-center justify-center opacity-0 group-hover:opacity-100"
              >
                <X className="w-4 h-4 text-gray-600 hover:text-red-600" />
              </button>

              <div className="flex justify-between mb-3">
                <div>
                  <p className="text-sm text-muted-foreground">{kpi.title}</p>
                  <h3 className="text-2xl font-semibold">{kpi.value}</h3>
                </div>
                <div
                  className="w-12 h-12 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: `${kpi.iconColor}15` }}
                >
                  <Icon name={kpi.icon} size={20} color={kpi.iconColor} />
                </div>
              </div>

              <div className="flex items-center gap-2 text-sm mb-2">
                <Icon
                  name={kpi.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'}
                  size={16}
                  color={kpi.changeType === 'positive'
                    ? 'var(--color-success)'
                    : 'var(--color-error)'}
                />
                <span>{kpi.change}%</span>
                <span className="text-muted-foreground">vs last period</span>
              </div>

              <div style={{ color: kpi.iconColor }}>
                {renderSparkline(kpi.sparklineData)}
              </div>
            </div>
          ))}

          {/* Add Metric */}
          {availableMetrics.length > 0 && (
            <div className="relative">
              <button
                onClick={() => setShowMetricSelector(!showMetricSelector)}
                className="w-full h-full min-h-[200px] border-2 border-dashed rounded-lg flex flex-col items-center justify-center gap-2 hover:bg-blue-50"
              >
                <Plus />
                <span>Add Metric</span>
              </button>

              {showMetricSelector && (
                <div className="absolute inset-0 bg-white border rounded-lg shadow-lg z-20 overflow-y-auto max-h-96">
                  {availableMetrics.map((metric) => (
                    <button
                      key={metric.id}
                      onClick={() => handleAddTile(metric)}
                      className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center gap-2"
                    >
                      <div
                        className="w-8 h-8 flex items-center justify-center rounded-lg"
                        style={{ backgroundColor: `${metric.iconColor}15` }}
                      >
                        <Icon name={metric.icon} size={16} color={metric.iconColor} />
                      </div>
                      {metric.title}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default KPITilesSection;


// import React, { useEffect, useState } from 'react';
// import { Plus, Calendar, ChevronDown, X } from 'lucide-react';
// import Button from '../../../components/ui/Button';
// import Icon from '../../../components/AppIcon';
// import api from '../../../api/axios'; // ✅ axios instance

// const KPITilesSection = () => {
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showDateDropdown, setShowDateDropdown] = useState(false);
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [showMetricSelector, setShowMetricSelector] = useState(false);

//   const [allKPIData, setAllKPIData] = useState([]);
//   const [visibleTiles, setVisibleTiles] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [customStartDate, setCustomStartDate] = useState('');
//   const [customEndDate, setCustomEndDate] = useState('');

//   const dateFilterOptions = [
//     'Today',
//     'Yesterday',
//     'Last 7 Days',
//     'Last 14 Days',
//     'Last Month',
//     'Custom Range'
//   ];

//   // ---------------- API (LATEST ARCH) ----------------
//   const fetchKpis = async (days) => {
//     try {
//       setLoading(true);

//       const response = await api.get(
//         `/api/v1/dashboard/kpi-metrics`,
//         {
//           params: { durationInDays: days }
//         }
//       );

//       if (!response.data?.success) {
//         throw new Error(response.data?.message || 'Operation failed');
//       }

//       const data = response.data.data;
//       setAllKPIData(data);
//       setVisibleTiles(data.slice(0, 6));
//     } catch (err) {
//       console.error('KPI fetch error:', err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchKpis(7);
//   }, []);

//   // ---------------- Date Filter ----------------
//   const handleDateFilterChange = (option) => {
//     let days = 7;

//     switch (option) {
//       case 'Today':
//       case 'Yesterday':
//         days = 1;
//         break;
//       case 'Last 7 Days':
//         days = 7;
//         break;
//       case 'Last 14 Days':
//         days = 14;
//         break;
//       case 'Last Month':
//         days = 30;
//         break;
//       case 'Custom Range':
//         setDateFilter(option);
//         setShowCustomRange(true);
//         setShowDateDropdown(false);
//         return;
//       default:
//         break;
//     }

//     setShowCustomRange(false);
//     setDateFilter(option);
//     setShowDateDropdown(false);
//     fetchKpis(days);
//   };

//   const applyCustomRange = () => {
//     if (!customStartDate || !customEndDate) return;

//     const start = new Date(customStartDate);
//     const end = new Date(customEndDate);
//     const days =
//       Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

//     fetchKpis(days);
//     setShowCustomRange(false);
//   };

//   // ---------------- Tile Controls ----------------
//   const handleAddTile = (metric) => {
//     setVisibleTiles((prev) => [...prev, metric]);
//     setShowMetricSelector(false);
//   };

//   const handleRemoveTile = (id) => {
//     setVisibleTiles((prev) =>
//       prev.filter((tile) => tile.id !== id)
//     );
//   };

//   const availableMetrics = allKPIData.filter(
//     (metric) =>
//       !visibleTiles.some((tile) => tile.id === metric.id)
//   );

//   // ---------------- Sparkline ----------------
//   const renderSparkline = (sparklineData) => {
//     if (!sparklineData || sparklineData.length === 0) return null;

//     const max = Math.max(...sparklineData);
//     const min = Math.min(...sparklineData);
//     const range = max - min || 1;
//     const padding = 10;

//     const points = sparklineData.map((value, index) => {
//       const x = (index / (sparklineData.length - 1)) * 100;
//       const y =
//         padding + ((max - value) / range) * (100 - 2 * padding);
//       return { x, y };
//     });

//     const pathD = points
//       .map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`)
//       .join(' ');

//     return (
//       <svg
//         className="w-full h-12 mt-3"
//         viewBox="0 0 100 100"
//         preserveAspectRatio="none"
//       >
//         <path
//           d={pathD}
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="2.5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           vectorEffect="non-scaling-stroke"
//           opacity="0.8"
//         />
//       </svg>
//     );
//   };

//   // ---------------- UI ----------------
//   return (
//     <div className="bg-white rounded-lg border border-border shadow-sm p-6 mb-6 md:mb-8">
//       {/* Header */}
//       <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
//         <div>
//           <h2 className="text-xl font-semibold text-foreground mb-1">
//             KPI Metrics
//           </h2>
//           <p className="text-sm text-muted-foreground">
//             Track key performance indicators across all channels
//           </p>
//         </div>

//         {/* Date Filter */}
//         <div className="relative">
//           <button
//             onClick={() => setShowDateDropdown(!showDateDropdown)}
//             className="flex items-center gap-2 px-4 py-2 bg-white border border-border rounded-lg hover:bg-gray-50 text-sm font-medium"
//           >
//             <Calendar className="w-4 h-4 text-muted-foreground" />
//             <span>{dateFilter}</span>
//             <ChevronDown className="w-4 h-4 text-muted-foreground" />
//           </button>

//           {showDateDropdown && (
//             <div className="absolute right-0 mt-2 w-48 bg-white border border-border rounded-lg shadow-lg z-10">
//               {dateFilterOptions.map((option) => (
//                 <button
//                   key={option}
//                   onClick={() => handleDateFilterChange(option)}
//                   className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 ${
//                     dateFilter === option
//                       ? 'bg-blue-50 text-blue-700 font-medium'
//                       : ''
//                   }`}
//                 >
//                   {option}
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Loading */}
//       {loading ? (
//         <div className="py-12 text-center text-muted-foreground">
//           Loading KPI metrics...
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
//           {visibleTiles.map((kpi) => (
//             <div
//               key={kpi.id}
//               className="bg-card border border-border rounded-lg p-4 md:p-6 relative group hover:shadow-lg"
//             >
//               <button
//                 onClick={() => handleRemoveTile(kpi.id)}
//                 className="absolute top-3 right-3 w-6 h-6 rounded-full bg-gray-100 hover:bg-red-100 flex items-center justify-center opacity-0 group-hover:opacity-100"
//               >
//                 <X className="w-4 h-4 text-gray-600 hover:text-red-600" />
//               </button>

//               <div className="flex justify-between mb-3">
//                 <div>
//                   <p className="text-sm text-muted-foreground">
//                     {kpi.title}
//                   </p>
//                   <h3 className="text-2xl font-semibold">
//                     {kpi.value}
//                   </h3>
//                 </div>
//                 <div
//                   className="w-12 h-12 rounded-lg flex items-center justify-center"
//                   style={{ backgroundColor: `${kpi.iconColor}15` }}
//                 >
//                   <Icon
//                     name={kpi.icon}
//                     size={20}
//                     color={kpi.iconColor}
//                   />
//                 </div>
//               </div>

//               <div className="flex items-center gap-2 text-sm mb-2">
//                 <Icon
//                   name={
//                     kpi.changeType === 'positive'
//                       ? 'TrendingUp'
//                       : 'TrendingDown'
//                   }
//                   size={16}
//                   color={
//                     kpi.changeType === 'positive'
//                       ? 'var(--color-success)'
//                       : 'var(--color-error)'
//                   }
//                 />
//                 <span>{kpi.change}%</span>
//                 <span className="text-muted-foreground">
//                   vs last period
//                 </span>
//               </div>

//               <div style={{ color: kpi.iconColor }}>
//                 {renderSparkline(kpi.sparklineData)}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default KPITilesSection;




 // ---------------- API (LATEST ARCH) ----------------
  const fetchKpis = async (days) => {
    try {
      setLoading(true);

      const response = await api.get(
        `/api/v1/dashboard/kpi-metrics`,
        {
          params: { durationInDays: days }
        }
      );

      if (!response.data?.success) {
        throw new Error(response.data?.message || 'Operation failed');
      }

      const data = response.data.data;
      setAllKPIData(data);
      setVisibleTiles(data.slice(0, 6));
    } catch (err) {
      console.error('KPI fetch error:', err.message);
    } finally {
      setLoading(false);
    }
  };
